import { APIHelper } from '@archistarai/auth-frontend';
import { findByKey } from 'vuex-intern';

export default {
  state: {
    roles: null,
    isUserRolesPopupActive: false,
    isRemoveUserPopupActive: false,
    isConvertToSystemUserPopupActive: false,
    selectedUserData: null
  },
  getters: {
    get: (state) => (name) => {
      return state.roles.find((u) => u.short_name === name);
    },
    whereRoleId: findByKey('roles', 'id')
  },
  mutations: {
    ADD_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_IS_USER_ROLES_POPUP_ACTIVE(state, value) {
      state.isUserRolesPopupActive = value;
    },
    SET_IS_REMOVE_USER_POPUP_ACTIVE(state, value) {
      state.isRemoveUserPopupActive = value;
    },
    SET_IS_CONVERT_TO_SYSTEM_USER_POPUP_ACTIVE(state, value) {
      state.isConvertToSystemUserPopupActive = value;
    },
    SET_SELECTED_USER_DATA(state, data) {
      state.selectedUserData = data;
    }
  },
  actions: {
    async getRoles({ commit, state }) {
      if (state.roles !== null) {
        //Already retrieved
        return;
      }

      try {
        const { data } = await APIHelper.AdminAPI.get('/roles?type=all');
        if (data && Object.keys(data).length) {
          commit('ADD_ROLES', Object.values(data));
        }
      } catch (e) {
        throw e;
      }
    },
    async getUserRoles({ _commit }, userGuid) {
      try {
        const { data } = await APIHelper.AdminAPI.get(`/users/${userGuid}/roles`);
        return data.data;
      } catch (e) {
        throw e;
      }
    },
    async getUserCompanyRoles({ _commit }, { userGuid, companyGuid }) {
      try {
        const { data } = await APIHelper.AdminAPI.get(`/users/${userGuid}/companies/${companyGuid}/roles`);
        return data.data;
      } catch (e) {
        throw e;
      }
    },
    async deleteUserRole({ _commit }, id) {
      try {
        const { data } = await APIHelper.AdminAPI.delete(`/user-roles/${id}`);
        return data.data;
      } catch (e) {
        throw e;
      }
    },
    async putUserCompanyRole({ _commit }, { userGuid, companyGuid, roleId, locationGuid }) {
      try {
        const { data } = await APIHelper.AdminAPI.put(`/users/${userGuid}/companies/${companyGuid}/roles`, {
          role_id: roleId,
          location_guid: locationGuid
        });
        return data.data;
      } catch (e) {
        throw e;
      }
    }
  }
};
